import semver from 'semver';
/**
 * Compares two semantic versions. If you pass in a not valid semantic version, it will return
 * `null`. If you need some massage for the kiosk build version, see `extractSemver`
 * @param v1 - This parameter must be in strict semantic version format.
 * @param v2 - This parameter must be in strict semantic version format.
 * @returns isOlderVersion, isSameVersion, isGreaterVersion
 */
export function semverCompare(v1, v2) {
    if (!semver.valid(v1)) {
        return null;
    }
    if (!semver.valid(v2)) {
        return null;
    }
    return {
        isOlderVersion: semver.lt(v1, v2),
        isSameVersion: semver.eq(v1, v2),
        isGreaterVersion: semver.gt(v1, v2),
    };
}
//# sourceMappingURL=versioning_helper.js.map